<template>
  <h2 v-html="text">{{ text }}</h2>
</template>

<script>
export default {
  name: 'Title',

  props: ['text'],
};
</script>

<style lang="scss" scoped>
@import '../../application';
@include mq($until: sm) {
  br {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/typo/Title.vue